import React, { useEffect, useRef, useState } from 'react'
import { useFormPageHandler, useMergeState, useForceRender } from 'irmlib/hooks'
import { FlexByRow, XDivider, YDivider, HalfScreen, useTheme, FlexGrowOne } from 'irmlib/styles'
import PropTypes from 'prop-types'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import * as regx from 'irmlib/components/FormControls/'
import { today, sameDayNextMonth } from 'irmlib/common'
import TemplateFormat from '../Template/TemplateFormation.jsx'
import { TextField, DateTime, Select, SaveButton, CancelButton, CheckBox, Autocomplete } from 'irmlib/components/FormControls'
import styled from 'styled-components'
import { Label, ThemeButton, Box, ClickableSvgIcon, ContainedButton, OutlinedButton } from 'irmlib/components/Controls'
import { Add } from 'irmlib/icons'
import Close from '../../../icons/svg/close'
import * as constants from 'irmlib/common/constants'
// import * as constants2 from '../../../irmlib/src/common/constants.js'
import { useHistory, useLocation } from 'react-router-dom'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { addFormTemplate } from 'irmlib/components/FormControls/common'
import { getUser } from '../../../redux/global'
import moment from 'moment'
import { clearBusy, setBusy, LocalToast, openGeneralDialog, closeGeneralDialog } from '../../../irmlib/src/containers'
import { successToast } from '../../../common/functions'
import { useTranslation } from 'react-i18next'
// import { totalNoOfBoxesForJob } from '../../../services/common/appConstants'


const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }
const BoxStyle = styled('div')`
    width: 25%; 
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    background-color: ${props => props.theme.palette.subPageHeaderBackground};
  `

const LableStyle = styled('div')`
    border-right: 1px solid;
  `

const AddBox = styled('div')`
    display: flex;
    justify-content: flex-end;
  `
const AlignCloseIcon = styled('div')`
display: flex;
justify-content: flex-end;
width: 10%;
`

const SelectDataEntryContainer = styled('div')`
  width: 100%;
`

const SelectVerificationContainer = styled('div')`
  width: 90%;
`

const StyledHalfScreen = styled(HalfScreen)`
  display: flex;
  flex-direction: row;
`
let title = ''


const getService = async () => {
  const getObject = {
    assignedUsers: []
  }
  return Promise.resolve(getObject)
}

const VerticalDivider = () =>
  <YDivider height='20px' />

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

const Buttons = props =>
  <>
    <CancelButton id={'editJob_button_cancel'} onClick={props.onClickCancel} arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton id={'editJob_button_save'} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.save' />
  </>

Buttons.propTypes = {
  arrRefs: PropTypes.array,
  postService: PropTypes.func,
  onClickCancel: PropTypes.func
}

const SELECT_COUNTRY = 0
const SELECT_WMS = 1
const SELECT_DISTRICT = 2
const SELECT_ORDER_NUMBER = 3
const SELECT_ACOUNT_LEVEL1 = 4
const SELECT_ACOUNT_LEVEL2 = 5
const SELECT_ACOUNT_LEVEL3 = 6
const SELECT_ASSET_TYPE = 7
const SELECT_TEMPLATE_NAME = 8
const TOTAL_BOXES = 9
const PICKUP_DATE = 10
const TARGET_DATE = 11
const SELECT_DATA_ENTRY_USER = 12
const SELECT_VERIFICATION_USER = 13
const SKP_INSTANCE = 14

const INITIAL_USER_COUNT = 1
const INITIAL_FIELD_COUNT = 16
const CHECK_FIELD_TRANSMIT = 15
const CHECK_UPLOAD_DATA = 17


const initialSate = {
  showTable: false,
  showPreview: false,
  fieldCount: 12,
  userCount: 1,
  jobIds: [],
  countryList: [],
  jobDetails: {},
  skpInstance: [constants.defaultSelect],
  wmsList: [],
  districtList: [],
  templateTypeList: [],
  templateNameList: [],
  orderNumber: [],
  accLevelOneList: [],
  accLevelTwoList: [],
  accLevelThreeList: [],
  templateDetails: [],
  entryUserList: [],
  verifyUserList: [],
  changedDataEntryUserList: [],
  originalDataEntryUserList: [],
  changedVerificationUserList: [],
  originalVerificationUserList: [],
  workerList: [],
  totalBoxes: 0,
  pickDate: null,
  targDate: null,
  verificationRequired: true,
  isUserRequired: true,
  dataEntryUser: '',
  verifyUser: '',
  translatedStatus: '',
  skpinstance: '',
  skpEncoding: {}
}

const EditJob = () => {
  const user = getUser()
  const { t } = useTranslation()
  const fileNumberRef = useRef()
  const refLocalBusyCursor = useRef(null)
  const [state, setState, getState] = useMergeState(initialSate)
  const tableRef = useRef(null)
  const refLocalToast = useRef(null)
  const theme = useTheme()
  const location = useLocation()
  const history = useHistory()
  const forceRender = useForceRender()
  const newFormFieldList = useRef([])
  const [errorList, setErrorList] = useState({})
  const [entryUserList, setEntryUserList] = useState({})

  useEffect(() => {
    getJobDetails()
  }, [])

  const formTemplate = [
    {
      label: 'templates.country',
      fieldKey: 'countryCode',
      isRequired: true
    },
    {
      label: 'templates.associatedWMSSystem',
      fieldKey: 'wmsCode',
      isRequired: true
    },
    {
      label: 'templates.district',
      fieldKey: 'districtId',
      isRequired: true
    },
    {
      label: 'templates.orderNumber',
      fieldKey: 'orderNumber',
      isRequired: false
    },
    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
    },
    {
      label: 'templates.templateType',
      fieldKey: 'dataEntryType',
      isRequired: false
    },
    {
      label: 'templates.templateName',
      fieldKey: 'templateName',
      isRequired: false
    },
    {
      label: 'templates.totalBoxes',
      fieldKey: 'totalBoxes',
      defaultValue: '',
      isRequired: true,
      maxLength: 4,
      regx: regx.digitsRegx,
      regxError: regx.digitsRegxError,
    },
    {
      label: 'templates.pickupDate',
      fieldKey: 'pickupDate',
      isRequired: true,
      validator: value => onSelectionFromDate(value),
    },
    {
      label: 'templates.targetDate',
      fieldKey: 'targetDate',
      isRequired: true,
      validator: value => onSelectionToDate(value),
    },
    {
      label: 'demo.dataEntryUser',
      fieldKey: 'assignedUsers.0.dataEntryUser',
      isRequired: getState().isUserRequired
    },
    {
      label: 'demo.verificationUser',
      fieldKey: 'assignedUsers.0.verificationUser',
      isRequired: getState().isUserRequired
    },
    {
      label: 'templates.skpinstance',
      fieldKey: 'skpinstance',
      isRequired: false
    },
    {
      fieldKey: 'autoTransmit',
      isRequired: true
    }
  ]

  const [arrRefs, data] = useFormPageHandler({ formTemplate, getService, busyOverride: refLocalBusyCursor })
  // eslint-disable-next-line no-unused-vars
  const [arrRefsTable, dataTable] = useFormPageHandler({ formTemplate, getService, busyOverride: refLocalBusyCursor })
  const handleErrorMsg = (userId, fieldCount, key) => {
    const updateErrorList = errorList
    if (key !== undefined) {
      updateErrorList[key] = userId
    }
    arrRefs[fieldCount]?.current?.setErrorMsg('messages.duplicateDeEntry')
    setErrorList(updateErrorList)
  }

  const handleErrorChange = (changingValue) => {
    const updateDataEntryList = entryUserList
    for (const [key, value] of Object.entries(errorList)) {
      if (value === changingValue) {
        for (const arr in arrRefs) {
          const keyCount = arrRefs[arr]?.current?.getFormTemplate().keyCount
          if (keyCount !== undefined && keyCount === parseInt(key)) {
            arrRefs[arr]?.current?.clearErrorMsg()
          }
        }
        delete errorList[key]
        updateDataEntryList[key] = value
        break
      }
    }

    setEntryUserList(updateDataEntryList)
  }

  const handleUserChange = (userType, newUser, index) => {
    if (newUser !== '--Select--' && newUser !== undefined) {
      if (userType === 'DataEntry') {
        setState({
          changedDataEntryUserList: { ...getState().changedDataEntryUserList, [index]: newUser },
        })
      } else if (userType === 'Verification') {
        setState({
          changedVerificationUserList: { ...getState().changedVerificationUserList, [index]: newUser },
        })
      }
    }
  }

  // onChange event for dynamically adding user fields
  const onChangeEntryUser = (e, userCount) => {
    handleUserChange('DataEntry', e, userCount)
    let isDisable = false
    let fieldKeyCount = 0

    // calculating fieldCount using the row count when we are adding users
    if (getState().verificationRequired) {
      fieldKeyCount = (userCount * 2) + 14
    } else {
      fieldKeyCount = userCount + 12
    }
    const uniqueKey = arrRefs[fieldKeyCount]?.current?.getFormTemplate().keyCount
    const localEntryUserList = entryUserList
    const changingValue = localEntryUserList[uniqueKey]

    const dataEntryUser = e

    const entryListValues = []
    const entryErrorList = []
    for (const key in errorList) {
      entryErrorList.push(errorList[key])
    }

    for (const key in localEntryUserList) {
      entryListValues.push(localEntryUserList[key])
    }

    handleErrorChange(changingValue)

    if (!entryListValues.includes(dataEntryUser) && dataEntryUser !== constants.defaultSelect) {
      arrRefs[fieldKeyCount]?.current?.clearErrorMsg()
      if (getState().verificationRequired) {
        arrRefs[fieldKeyCount + 1]?.current?.setValue(dataEntryUser)
      }
      if (uniqueKey !== undefined) {
        localEntryUserList[uniqueKey] = dataEntryUser
      }

      setEntryUserList(localEntryUserList)
      isDisable = false
    } else if (entryListValues.includes(dataEntryUser)) {
      arrRefs[fieldKeyCount]?.current?.clearErrorMsg()

      handleErrorMsg(dataEntryUser, fieldKeyCount, uniqueKey)
      isDisable = true
    }

    setState({ isSubmit: isDisable })
  }

  const handleEntryCloseIcon = (index, count) => {
    // removing the user pair from arrRefs
    for (const key in arrRefs) {
      const keyCount = arrRefs[key]?.current?.getFormTemplate().keyCount
      if (keyCount !== undefined) {
        if (keyCount === index) {
          if (getState().verificationRequired) {
            arrRefs.splice(key, 2)
            delete errorList[keyCount]
            delete entryUserList[keyCount]
            break
          } else {
            arrRefs.splice(key, 1)
            delete errorList[keyCount]
            delete entryUserList[keyCount]
            break
          }
        }
      }
    }

    // removing the user pair from the form array
    newFormFieldList.current.forEach((ele, i) => {
      if (parseInt(ele.key) === index) {
        newFormFieldList.current.splice(i, 1)
      }
    })

    forceRender()
    setState({ isSubmit: false })
  }

  const getJobDetails = async () => {
    setBusy()
    const userLoggedInDistrict = getUser().district
    const jobId = location.pathname.split('/')[2]
    const jobDoc = await gdeTransactions.getJobById(jobId)
    const jobDetails = jobDoc.data()
    const statusTranslated = t(`jobStatusObj.${jobDetails.jobStatus}`)
    const boxDetails = await gdeTransactions.getBoxesForJob(jobId)
    const countryDoc = await gdeTransactions.getCountryByID(jobDetails.countryCode)
    const countryData = countryDoc.data()
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    // const workerCollection = await gdeTransactions.getWorkersWithDistrict(loggedInUserDistrict)
    const workerCollection = await gdeTransactions.getworkersLists(userLoggedInDistrict)
    const workerDropList = [defaultSelectOption]
    const workerList = []
    const userList = []

    workerCollection.forEach((doc) => {
      if (!doc.data().isDeleted) {
        workerDropList.push({
          value: doc.id,
          label: `${doc.data().firstName} ${doc.data().lastName}-${doc.id.replace(/\d(?=\d{3})/g, '*')}`
        })
      }
      workerList[doc.id] = doc.data()
    })

    const countryList = [{ value: countryDoc.id, label: `${countryDoc.id}-${countryData.countryName}` }]
    const wmsList = [{ value: jobDetails.wmsCode, label: jobDetails.wmsCode }]
    const districtList = [{ value: jobDetails.districtId, label: jobDetails.districtId }]
    const templateTypeList = [{ value: jobDetails.dataEntryType, label: jobDetails.dataEntryType }]
    const skpInstance = [{ value: jobDetails.skpinstance ? jobDetails.skpinstance : constants.defaultSelect, label: jobDetails.skpinstance ? jobDetails.skpinstance : constants.defaultSelect }]

    const templateNameList = [{
      value: jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName,
      label: jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName
    }]
    const orderNumber = [{ value: jobDetails.orderNumber, label: jobDetails.orderNumber }]
    const accLevelOneList = [{ value: jobDetails.accountLevel1.toUpperCase(), label: jobDetails.accountLevel1.toUpperCase() }]
    const accLevelTwoList = [{ value: jobDetails.accountLevel2.toUpperCase(), label: jobDetails.accountLevel2.toUpperCase() }]
    const accLevelThreeList = [{ value: jobDetails.accountLevel3.toUpperCase(), label: jobDetails.accountLevel3.toUpperCase() }]
    const autoTransmit = jobDetails.autoTransmit


    arrRefs[TOTAL_BOXES].current.setValue(jobDetails.totalBoxes)

    const pickupDate = moment(jobDetails.pickupDate.seconds, 'X').format('YYYY-MM-DD')
    const targetDate = moment(jobDetails.targetDate.seconds, 'X').format('YYYY-MM-DD')

    // const templateName = jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName
    // const template = await gdeTransactions.getTemplateById(templateName)
    const templateDetails = jobDetails.templateData
    // const templateDetails = template.data()
    let isUserRequired = state.isUserRequired
    let isVerify = false
    const fields = templateDetails.templateFields
    Object.keys(fields).map((key) => {
      if (fields[key].verify) {
        isVerify = true
      }
      return null
    })

    if (jobDetails.jobStatus === constants.jobStatus.pending) {
      isUserRequired = false
      formTemplate[SELECT_DATA_ENTRY_USER].isRequired = false
    }

    setState({
      jobId: jobId,
      jobDetails: jobDetails,
      countryCode: jobDetails?.countryCode,
      countryList: countryList,
      wmsList: wmsList,
      districtList: districtList,
      templateTypeList: templateTypeList,
      skpInstance: skpInstance,
      templateNameList: templateNameList,
      orderNumber: orderNumber,
      accLevelOneList: accLevelOneList,
      accLevelTwoList: accLevelTwoList,
      accLevelThreeList: accLevelThreeList,
      entryUserList: workerDropList,
      verifyUserList: workerDropList,
      workerList: workerList,
      totalBoxes: boxDetails.size,
      pickDate: pickupDate,
      targDate: targetDate,
      verificationRequired: isVerify,
      isUserRequired: isUserRequired,
      autoTransmit: autoTransmit,
      translatedStatus: statusTranslated,
      skpEncoding: skpEncoding
    })
    setState({ skpinstance: getState()?.skpInstance[0]?.value })

    let i = 0
    if (jobDetails.assignedUsers) {
      for (const user in jobDetails.assignedUsers) {
        if (jobDetails.assignedUsers[user].jobCategory.includes('Data Entry User')) {
          userList[i] = {
            dataEntryUser: user,
            verificationUser: jobDetails.assignedUsers[user].verifyUser
          }

          setState({
            originalDataEntryUserList: { ...getState().originalDataEntryUserList, [i]: user },
            originalVerificationUserList: { ...getState().originalVerificationUserList, [i]: jobDetails.assignedUsers[user].verifyUser },
          })
          i++
        }
      }

      if (userList.length !== 0) {
        arrRefs[SELECT_DATA_ENTRY_USER]?.current?.setValue(userList[0].dataEntryUser)
        if (getState().verificationRequired) {
          arrRefs[SELECT_VERIFICATION_USER]?.current?.setValue(userList[0].verificationUser)
        }
      }


      let index = INITIAL_FIELD_COUNT
      for (let key = 1; key < userList.length; key++) {
        addFormField()
        arrRefs[index]?.current?.setValue(userList[key].dataEntryUser)
        if (getState().verificationRequired) {
          arrRefs[index + 1]?.current?.setValue(userList[key].verificationUser)
          index = index + 2
        } else {
          index = index + 1
        }
      }
    }

    // setting default values
    arrRefs[SELECT_COUNTRY].current.setValue(countryDoc.id)
    arrRefs[SELECT_WMS].current.setValue(jobDetails.wmsCode)
    arrRefs[SELECT_DISTRICT].current.setValue(jobDetails.districtId)
    arrRefs[SELECT_ASSET_TYPE].current.setValue(jobDetails.dataEntryType)
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setValue(jobDetails.accountLevel1.toUpperCase())
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setValue(jobDetails.accountLevel2.toUpperCase())
    arrRefs[SKP_INSTANCE].current.setValue(jobDetails.skpinstance ? jobDetails.skpinstance : constants.defaultSelect)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setValue(jobDetails.accountLevel3.toUpperCase())
    arrRefs[PICKUP_DATE].current.setValue(pickupDate)
    arrRefs[TARGET_DATE].current.setValue(targetDate)
    arrRefs[SELECT_ORDER_NUMBER].current.setValue(jobDetails.orderNumber)
    // arrRefs[CHECK_FIELD_TRANSMIT].current.setValue(!(state.jobDetails.autoTransmit === 'false') ? false : 'true')

    clearBusy()
  }

  const arr = [...newFormFieldList.current]
  const addFormField = () => {
    // key should be unique for each pair of users 
    const userCount = Math.floor((Math.random() * 100) + INITIAL_USER_COUNT)
    const count = newFormFieldList.current.length + INITIAL_USER_COUNT
    const dataEntryAdd = {
      label: 'demo.dataEntryUser',
      fieldKey: `assignedUsers.${userCount}.dataEntryUser`,
      defaultValue: constants.defaultSelect,
      isRequired: true,
      keyCount: userCount
    }

    const verificationAdd = {
      label: 'demo.verificationUser',
      fieldKey: `assignedUsers.${userCount}.verificationUser`,
      defaultValue: constants.defaultSelect,
      isRequired: true,
      keyCount: userCount
    }

    const dataEntryUser = addFormTemplate({ fieldTemplate: dataEntryAdd, Component: Autocomplete, props: { options: getState().entryUserList, noTranslateItems: true, onChange: (e) => onChangeEntryUser(e, count) }, arrRefs })
    let verificationUser
    if (getState().verificationRequired) {
      verificationUser = addFormTemplate({ fieldTemplate: verificationAdd, Component: Autocomplete, props: { options: getState().verifyUserList, noTranslateItems: true, onChange: (e) => onChangeVerificationUser(e, count) }, arrRefs })
    }

    let allowToRemoveUsers = false
    if (getState()?.jobDetails?.jobStatus === constants?.jobStatus?.assigned) {
      allowToRemoveUsers = true
    }

    const newIndex = newFormFieldList.current.length
    newFormFieldList.current.push(
      <div key={userCount}>
        <FlexByRow>
          <StyledHalfScreen>
            <SelectDataEntryContainer>
              {dataEntryUser}
            </SelectDataEntryContainer>
          </StyledHalfScreen>
          <XDivider width='50px' />
          <StyledHalfScreen>
            {getState().verificationRequired
              ? <SelectVerificationContainer>
                {verificationUser}
              </SelectVerificationContainer>
              : null
            }
            {allowToRemoveUsers
              ? <AlignCloseIcon>
                <ClickableSvgIcon
                  onClick={() => handleEntryCloseIcon(userCount, newIndex)}
                >
                  <Close scale={0.7} >
                  </Close>
                </ClickableSvgIcon>
              </AlignCloseIcon>
              : null
            }
          </StyledHalfScreen>
        </FlexByRow>
        <VerticalDivider />
      </div>
    )

    forceRender()
  }

  const getTableData = async () => {
    const templateName = state.jobDetails.templateName ? state.jobDetails.templateName : state.jobDetails.standardTemplateName
    if (templateName !== undefined) {
      // const template = await gdeTransactions.getTemplateById(templateName)
      const template = state.jobDetails.templateData
      // setState({ templateDetails: template.data() })
      setState({ templateDetails: template })
      // const fields = template.data().templateFields
      const fields = template.templateFields
      const arrayFields = Object.keys(fields).map((key) => {
        const data = fields[key]
        data.name = key
        return data
      })
      arrayFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))
      return Promise.resolve(arrayFields)
    }
    return Promise.resolve([])
  }

  const getJobDoc = (postObject, customTemplateName, customTemplateData) => {
    const userKeys = {}
    const dataEntryUsers = []
    const verificationUsers = []
    let assignUserList = []
    let isValid = true
    const { jobDetails, verificationRequired, workerList, templateDetails } = getState()


    if (Object.keys(postObject.assignedUsers).length === 1) {
      if (verificationRequired) {
        if ((postObject.assignedUsers['0'].dataEntryUser || postObject.assignedUsers['0'].verificationUser) === undefined) {
          isValid = false
        }
      } else {
        if (postObject.assignedUsers['0'].dataEntryUser === undefined) {
          isValid = false
        }
      }
    }
    if (isValid) {
      for (const key in postObject.assignedUsers) {
        const obj = postObject.assignedUsers[key]
        if (!dataEntryUsers.includes(obj.dataEntryUser)) {
          dataEntryUsers.push(obj.dataEntryUser)
        }
        if (verificationRequired && !verificationUsers.includes(obj.verificationUser)) {
          verificationUsers.push(obj.verificationUser)
        }

        if (obj.dataEntryUser in userKeys) {
          userKeys[obj.dataEntryUser].jobCategory = ['Data Entry User']
          if (verificationRequired) {
            userKeys[obj.dataEntryUser].verifyUser = obj.verificationUser
          }
        } else {
          userKeys[obj.dataEntryUser] = {
            completedBoxes: 0,
            status: workerList[obj.dataEntryUser].status ? workerList[obj.dataEntryUser].status : '',
            jobCategory: ['Data Entry User'],
            verifyUser: verificationRequired ? obj.verificationUser : '',
            workerName: `${workerList[obj.dataEntryUser].firstName} ${workerList[obj.dataEntryUser].lastName}`
          }
        }

        if (verificationRequired) {
          if (obj.verificationUser in userKeys) {
            if (userKeys[obj.verificationUser].jobCategory === undefined) {
              userKeys[obj.verificationUser].jobCategory = []
            }
            userKeys[obj.verificationUser].jobCategory.push('Verification User')
          } else {
            userKeys[obj.verificationUser] = {
              completedBoxes: 0,
              status: workerList[obj.verificationUser].status ? workerList[obj.verificationUser].status : '',
              jobCategory: ['Verification User'],
              workerName: `${workerList[obj.verificationUser].firstName} ${workerList[obj.verificationUser].lastName}`
            }
          }
        }
      }
    }
    assignUserList = Object.keys(userKeys)
    // if (getState()?.jobDetails?.dataEntryType === 'Maintenance Box' || getState()?.jobDetails?.dataEntryType === 'New Box' || getState()?.jobDetails?.dataEntryType === 'Maintenance File' || getState()?.jobDetails?.dataEntryType === 'New File') {
    //   postObject.totalBoxes = totalNoOfBoxesForJob
    // }

    const jobDoc = {
      jobStatus: isValid && jobDetails.jobStatus === constants.jobStatus.pending ? constants.jobStatus.assigned : jobDetails.jobStatus,
      standardTemplateName: templateDetails.standardTemplateName ? templateDetails.standardTemplateName : templateDetails.templateName,
      dataEntryType: postObject.dataEntryType,
      accountLevel1: postObject.accountLevel1.toUpperCase(),
      accountLevel2: postObject.accountLevel2.toUpperCase(),
      accountLevel3: postObject.accountLevel3.toUpperCase(),
      orderNumber: postObject.orderNumber ? postObject.orderNumber : '',
      wmsCode: postObject.wmsCode,
      districtId: postObject.districtId,
      countryCode: postObject.countryCode,
      actionBy: user.workerId,
      actionTs: new Date(),
      recordNotifyCount: jobDetails.recordNotifyCount,
      pickupDate: new Date(postObject.pickupDate),
      targetDate: new Date(postObject.targetDate),
      // totalBoxes: parseInt(postObject.totalBoxes),
      templateName: customTemplateName,
      templateData: customTemplateData,
      assignedUsers: userKeys,
      createdBy: jobDetails.createdBy,
      createdTs: jobDetails.createdTs,
      assignedUserList: assignUserList
    }
    return jobDoc
  }

  const updateCustomTemplate = async (postObject, customTemplateName) => {
    const arrPost = tableRef?.current?.dataManager.data
    const fields = {}
    let costomOrder = 1
    arrPost.forEach(r => {
      if (r?.tableData?.checked) {
        delete r.rowSelected
        delete r.tableData
        const fieldName = r.name
        delete r.name
        delete r.isRequiredChanged
        r.customOrder = costomOrder
        costomOrder++
        fields[fieldName] = r
      }
    })

    const templateData = {
      countryCode: postObject.countryCode,
      wmsCode: getState().templateDetails.wmsCode,
      accountLevel1: postObject.accountLevel1.toUpperCase(),
      accountLevel2: postObject.accountLevel2.toUpperCase(),
      accountLevel3: postObject.accountLevel3.toUpperCase(),
      dataEntryType: postObject.dataEntryType,
      templateType: getState().templateDetails.templateType,
      standardTemplateName: getState().templateDetails.standardTemplateName ? getState().templateDetails.standardTemplateName : getState().templateDetails.templateName,
      templateName: customTemplateName,
      templateFields: fields,
      lastUsed: new Date()
    }
    if (Object.keys(fields).length !== 0) {
      // await gdeTransactions.updateTemplate(customTemplateName, templateData)
      return templateData
    } else {
      history.goBack()
    }
  }
  const statusUpdateForJob = async (jobDetail) => {
    const collection = await gdeTransactions.getBoxesForJob(jobDetail.jobId)
    const boxList = []
    const boxUserList = []

    collection.forEach((doc) => {
      const data = doc.data()
      boxList.push({
        boxId: data.boxId,
        entryUser: data.dataEntryUser,
        status: data.status,
        dataEntryUser: data.dataEntryUser,
        verificationUser: data.verificationUser
      })
      boxUserList.push(doc.data().dataEntryUser)
    })
  }

  const postService = async postObject => {
    const originalDataEntryUserList = getState()?.originalDataEntryUserList
    const changedDataEntryUserList = getState()?.changedDataEntryUserList
    const originalVerificationUserList = getState()?.originalVerificationUserList
    const changedVerificationUserList = getState()?.changedVerificationUserList
    let customTemplateData
    const boxList = []
    const boxUserList = []
    const collection = await gdeTransactions.getBoxesForJob(getState().jobDetails.jobId)
    collection.forEach((doc) => {
      const data = doc.data()
      boxList.push({
        boxId: data.boxId,
        entryUser: data.dataEntryUser,
        status: data.status,
        dataEntryUser: data.dataEntryUser,
        verificationUser: data.verificationUser
      })
      boxUserList.push(doc.data().dataEntryUser)
    })

    let boxData = {}
    boxList.forEach((box) => {
      for (const user in originalDataEntryUserList) {
        if (originalDataEntryUserList[user] !== changedDataEntryUserList[user]) {
          if (box.dataEntryUser === originalDataEntryUserList[user]) {
            if (box.status === constants.boxStatus.dataEntryInProcess || box.status === constants.boxStatus.requiresReKey) {
              const boxId = box.boxId
              const boxStatus = box.status ? box.status : ''
              delete box.status
              boxData = {
                actionTs: new Date(),
                dataEntryUser: changedDataEntryUserList[user]
              }
              
              gdeTransactions.updateBox(getState().jobDetails.jobId, boxId, boxData)
              box.status = boxStatus
            } else {
              // eslint-disable-next-line
              postObject.assignedUsers['avg' + user] = {
                dataEntryUser: originalDataEntryUserList[user],
                verificationUser: originalVerificationUserList[user] || originalDataEntryUserList[user],
              }
            }
          }
        }
      }

      for (const user in originalVerificationUserList) {
        if (originalVerificationUserList[user] !== changedVerificationUserList[user]) {
          if (box.dataEntryUser === originalDataEntryUserList[user]) {
            if (box.status === constants.boxStatus.dataEntryInProcess || box.status === constants.boxStatus.readyForVerification || box.status === constants.boxStatus.requiresReKey || box.status === constants.boxStatus.verificationInProcess) {
              const boxId = box.boxId
              const boxStatus = box.status ? box.status : ''
              delete box.status
              boxData = {
                actionTs: new Date(),
                verificationUser: changedVerificationUserList[user] || changedDataEntryUserList[user]
              }
              gdeTransactions.updateBox(getState().jobDetails.jobId, boxId, boxData)
              box.status = boxStatus
            }
          }
        }
      }


      // if (getState().verificationRequired && (box.status === constants.boxStatus.dataEntryInProcess || box.status === constants.boxStatus.readyForVerification || box.status === constants.boxStatus.requiresReKey || box.status === constants.boxStatus.verificationInProcess)) {
      //   const boxId = box.boxId
      //   const boxStatus = box.status ? box.status : ''
      //   delete box.status
      //   boxData = {
      //     actionTs: new Date(),
      //     verificationUser: getState().verifyUser,
      //   }
      //   // gdeTransactions.updateBox(getState().jobDetails.jobId, boxId, boxData)
      //   box.status = boxStatus
      // } 
    })



    // if (parseInt(arrRefs[TOTAL_BOXES].current.getValue()) >= boxList.length) {
    if (getState().jobDetails.templateName) {
      customTemplateData = await updateCustomTemplate(postObject, getState().jobDetails.templateName)
    }

    const jobData = getJobDoc(postObject, getState().jobDetails.templateName, customTemplateData)
    if (fileNumberRef.current.getValue() === undefined) {
      jobData.autoTransmit = getState().jobDetails.autoTransmit
    } else {
      if (fileNumberRef.current.getValue() === true) {
        jobData.autoTransmit = 'false'
      } else {
        jobData.autoTransmit = 'true'
      }
    }
    jobData.autoTransmitAndStatus = `${jobData.autoTransmit}-${getState().jobDetails.jobStatus}`
    // jobData.totalBoxes = parseInt(arrRefs[TOTAL_BOXES].current.getValue())
    await gdeTransactions.updateJob(getState().jobId, jobData)
    await statusUpdateForJob(getState().jobDetails)

    // code to update job last modify date in gdeMetrics collection 
    const jobMetricsData = await gdeTransactions.getJobMetrics(getState().jobId, false)
    jobMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, activityType } = data
      if (metricsFileId !== undefined && activityType !== 'retransmit') {
        const metricsData = {
          jobLastModifyTs: new Date(),
          updatedTs: new Date(),
        }
        gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })

    successToast({ message: t('toast.jobSaved', { jobId: getState().jobId, templateName: getState().jobDetails.templateName }), title: t('toast.jobManagement') })
    history.goBack()
    // } else {
    //   arrRefs[TOTAL_BOXES].current.setErrorMsg(`Count Must be more than or equal to ${boxList.length}`, true)

    //   // Need to handle tranaction
    // }
  }

  // backend data conversion for template types
  state.templateTypeList.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`templateTypeObj.${element.value}`)
    }
  })

  // onChange event for fixed user fields
  const onChangeDeUser = (e) => {
    handleUserChange('DataEntry', e, 0)
    const localEntryUserList = entryUserList
    const changingValue = localEntryUserList[SELECT_DATA_ENTRY_USER]
    let isDisable = false
    const dataEntryUser = e
    const entryListValues = []
    const entryErrorList = []
    for (const key in errorList) {
      entryErrorList.push(errorList[key])
    }

    for (const key in localEntryUserList) {
      entryListValues.push(localEntryUserList[key])
    }

    handleErrorChange(changingValue)

    if (!entryListValues.includes(dataEntryUser) && dataEntryUser !== constants.defaultSelect) {
      arrRefs[SELECT_DATA_ENTRY_USER]?.current?.clearErrorMsg()
      if (getState().verificationRequired) {
        arrRefs[SELECT_VERIFICATION_USER].current.setValue(dataEntryUser)
      }
      localEntryUserList[SELECT_DATA_ENTRY_USER] = dataEntryUser
      setEntryUserList(localEntryUserList)
      isDisable = false
    } else if (entryListValues.includes(dataEntryUser)) {
      handleErrorMsg(dataEntryUser, SELECT_DATA_ENTRY_USER)
      isDisable = true
    }
    setState({ isSubmit: isDisable })
  }

  const onChangeVerifier = (e) => {
    handleUserChange('Verification', e, 0)
    const verifyUser = e
    setState({ verifyUser: verifyUser })
  }

  const onChangeVerificationUser = (e, userCount) => {
    handleUserChange('Verification', e, userCount)
    const verifyUser = e
    setState({ verifyUser: verifyUser })
  }


  const onChangeTemplate = (value) => {
    if (value === undefined || value === constants.defaultSelect) {
      setState({ showTable: false })
    } else {
      title = value
      setState({ showTable: true })
    }
  }
  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.goBack()
  }

  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton id={'EditJob_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'EditJob_dialogBoxButton_yes'} onClick={handleCancelButtonOnClick} >buttons.yes</ContainedButton>
    </>

  const handleCancel = () => {
    openGeneralDialog({
      title: t('options.cancelJobTitle'),
      message: t('options.cancelJobMessage'),
      noTranslateTitle: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  const onSelectionFromDate = (value) => {
    const targetDateValue = arrRefs[TARGET_DATE].current.getValue()
    const target = new Date(targetDateValue).getTime()
    const pickup = new Date(value).getTime()
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000

    if (state.pickDate === value) {
      return
    }

    if (pickup > target) {
      return 'messages.pickupDateValidation'
    }

    if (target - pickup < thirtyDaysInMs) {
      return 'messages.lessThan30Days'
    }

    const todayDate = new Date()
    const today = new Date(todayDate).getTime()

    if (pickup < today) {
      return 'messages.pickupDateSelectedOldDate'
    }
    return ''
  }

  const onSelectionToDate = (value) => {
    const pickupDate = arrRefs[PICKUP_DATE].current.getValue()
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000
    const pickup = new Date(pickupDate).getTime()
    const target = new Date(value).getTime()

    if (state.targDate === value) {
      return
    }

    if (target < pickup) {
      return 'messages.targetDateValidation'
    }

    if (target - pickup < thirtyDaysInMs) {
      return 'messages.lessThan30Days'
    }

    const todayDate = new Date()
    const today = new Date(todayDate).getTime()

    if (target < today) {
      return 'messages.targetDateSelectedOldDate'
    }

    return ''
  }


  const handleEOnInput = async (evt) => {
    if (evt.keyCode === 13) {
      const collection = await gdeTransactions.getBoxesForJob(getState().jobDetails.jobId)
      const boxList = []
      const boxUserList = []

      collection.forEach((doc) => {
        const data = doc.data()
        boxList.push({
          boxId: data.boxId,
          entryUser: data.dataEntryUser,
          status: data.status,
          dataEntryUser: data.dataEntryUser,
          verificationUser: data.verificationUser
        })
        boxUserList.push(doc.data().dataEntryUser)
      })
      if (!(parseInt(arrRefs[TOTAL_BOXES].current.getValue()) >= boxList.length)) {
        arrRefs[TOTAL_BOXES].current.setErrorMsg(`Count Must be more than or equal to ${boxList.length}`, true)
      }
    }
    if (evt.key === 'e' || evt.key === 'E' || evt.key === '-') {
      evt.preventDefault()
      /* eslint no-useless-return: */
      return
    }
  }

  return (
    <>
      <MainRouteSubRoutePage
        mainTitle='routeTitles.jobManagement'
        subTitle={<GoBackSubtitle title='editJob.editJobDetails' />}
        buttons={<Buttons arrRefs={arrRefs} postService={postService} onClickCancel={handleCancel} />}
      >
        <LocalToast ref={refLocalToast} />
        <FlexByRow>
          {/* {console.log('state.jobDetails', arrRefs[CHECK_FIELD_TRANSMIT].current.getValue())} */}
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>demo.jobID</Label></LableStyle>
              <YDivider />
              <LableStyle>{state.jobId}</LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>demo.jobStatus</Label></LableStyle>
              <YDivider />
              <LableStyle>{state?.translatedStatus}</LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>editJob.totalBoxesReady</Label></LableStyle>
              <YDivider />
              <LableStyle><Label noTranslate>{getState()?.jobDetails?.dataEntryType === 'Maintenance Box' || getState()?.jobDetails?.dataEntryType === 'New Box' || getState()?.jobDetails?.dataEntryType === 'Maintenance File' || getState()?.jobDetails?.dataEntryType === 'New File' ? state.jobDetails.totalBoxes : '-'}</Label></LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <Label>editJob.totalBoxesPending</Label>
              <YDivider />
              <Label>{state.jobDetails.boxesCompleted ? state.jobDetails.boxesCompleted : 0}</Label>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <Label>editJob.manualTransmit</Label>
              <YDivider />
              <Label><CheckBox checked={!(state.jobDetails.autoTransmit === 'false') ? false : 'true'} fieldTemplate={formTemplate[CHECK_FIELD_TRANSMIT]} ref={fileNumberRef} disabled={state.jobDetails.jobStatus === constants.jobStatus.inProgress || state.jobDetails.jobStatus === constants.jobStatus.transmitted || state.jobDetails.jobStatus === constants.jobStatus.approved || getState()?.jobDetails?.dataEntryType === 'Maintenance Box' || getState()?.jobDetails?.dataEntryType === 'New Box'} /></Label>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <Label>editJob.uploadCustomerData</Label>
              <YDivider />
              <Label><CheckBox checked={state?.jobDetails?.isUploadCustomerDataFile} fieldTemplate={formTemplate[CHECK_UPLOAD_DATA]} disabled={true} /></Label>
            </Box>
          </BoxStyle>
        </FlexByRow>
        <VerticalDivider />
        <FlexByRow>
          <HalfScreen>
            <Select
              id={'editJob_country'}
              data={data}
              items={state.countryList}
              fieldTemplate={formTemplate[SELECT_COUNTRY]}
              ref={arrRefs[SELECT_COUNTRY]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'editJob_wms'}
              data={data}
              items={state.wmsList}
              fieldTemplate={formTemplate[SELECT_WMS]}
              ref={arrRefs[SELECT_WMS]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'editJob_district'}
              data={data}
              items={state.districtList}
              fieldTemplate={formTemplate[SELECT_DISTRICT]}
              ref={arrRefs[SELECT_DISTRICT]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'editJob_skpInstance'}
              data={data}
              items={state.skpInstance}
              fieldTemplate={formTemplate[SKP_INSTANCE]}
              ref={arrRefs[SKP_INSTANCE]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <TextField id={'createJob_orderNumber'} data={data} fieldTemplate={formTemplate[SELECT_ORDER_NUMBER]} ref={arrRefs[SELECT_ORDER_NUMBER]} disabled={false} />
            <VerticalDivider />
            <TextField
              id={'editJob_accountLevel1'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Autocomplete
              id={'editJob_dataEntryUser'}
              onChange={onChangeDeUser}
              data={data}
              options={state.entryUserList}
              fieldTemplate={formTemplate[SELECT_DATA_ENTRY_USER]}
              ref={arrRefs[SELECT_DATA_ENTRY_USER]}
              disabled={(state.jobDetails.jobStatus === constants.jobStatus.transmitted || state.jobDetails.jobStatus === constants.jobStatus.readyToTransmit)}
              noTranslateItems
            />
            {/* <TextField
              id={'editJob_accountLevel2'}
              data={data}
              fieldTemplate={formTemplate[SELECT_DATA_ENTRY_USER]}
              ref={arrRefs[SELECT_DATA_ENTRY_USER]}
              noTranslateItems
              disabled={true}
            /> */}
            <VerticalDivider />
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>

            <TextField
              id={'editJob_accountLevel2'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <TextField
              id={'editJob_accountLevel3'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'editJob_assetType'}
              data={data}
              items={state.templateTypeList}
              fieldTemplate={formTemplate[SELECT_ASSET_TYPE]}
              ref={arrRefs[SELECT_ASSET_TYPE]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select noTranslateItems
              id={'editJob_templateType'}
              onChange={(e) => onChangeTemplate(e)}
              data={data}
              items={state.templateNameList}
              fieldTemplate={formTemplate[SELECT_TEMPLATE_NAME]}
              ref={arrRefs[SELECT_TEMPLATE_NAME]}
              disabled={true}
            />
            <VerticalDivider />
            {getState()?.jobDetails?.dataEntryType !== 'Maintenance Box' && getState()?.jobDetails?.dataEntryType !== 'New Box' && getState()?.jobDetails?.dataEntryType !== 'Maintenance File' && getState()?.jobDetails?.dataEntryType !== 'New File' &&
              <>
                <TextField
                  id={'editJob_totalBoxes'}
                  data={data}
                  fieldTemplate={formTemplate[TOTAL_BOXES]}
                  ref={arrRefs[TOTAL_BOXES]}
                  type='number'
                  onKeyDown={(evt) => handleEOnInput(evt)}
                />
                <VerticalDivider />
              </>
            }
            <FlexByRow>
              <FlexGrowOne>
                <DateTime
                  id={'editJob_pickupDate'}
                  data={data}
                  fieldTemplate={formTemplate[PICKUP_DATE]}
                  ref={arrRefs[PICKUP_DATE]}
                  disabled={!(state.jobDetails.jobStatus === constants.jobStatus.assigned || state.jobDetails.jobStatus === constants.jobStatus.pending)}
                  type='date'
                  minDate={today()}
                />
              </FlexGrowOne>
              <XDivider width='20px' />
              <FlexGrowOne>
                <DateTime
                  id={'editJob_targetDate'}
                  data={data}
                  fieldTemplate={formTemplate[TARGET_DATE]}
                  ref={arrRefs[TARGET_DATE]}
                  disabled={!(state.jobDetails.jobStatus === constants.jobStatus.assigned || state.jobDetails.jobStatus === constants.jobStatus.pending)}
                  type='date'
                  minDate={sameDayNextMonth()}
                />
              </FlexGrowOne>
            </FlexByRow>
            <YDivider height='20px' />
            {state?.verificationRequired
              ? <Autocomplete
                  id={'editJob_verficationUser'}
                  onChange={onChangeVerifier}
                  data={data}
                  style={{ paddingTop: '65px' }}
                  options={state.verifyUserList}
                  fieldTemplate={formTemplate[SELECT_VERIFICATION_USER]}
                  ref={arrRefs[SELECT_VERIFICATION_USER]}
                  disabled={(state.jobDetails.jobStatus === constants.jobStatus.transmitted || state.jobDetails.jobStatus === constants.jobStatus.readyToTransmit)}
                  noTranslateItems
              />
              : null}
            <VerticalDivider />
          </HalfScreen>
        </FlexByRow>
        {arr}
        <AddBox>
          <Box>
            <BottomPaddedButton id={'editJob_addUser'} onClick={addFormField} startIcon={<Add />} variant='contained' disabled={!(state.jobDetails.jobStatus === constants.jobStatus.assigned) && !(state.jobDetails.jobStatus === constants.jobStatus.inProgress)}>
              editJob.addUser
            </BottomPaddedButton>
          </Box>
        </AddBox>
        <XDivider width='20px' />
        {getState().showTable
          ? <>
            <VerticalDivider />
            <TemplateFormat
              tableRef={tableRef}
              getState={getState}
              setState={setState}
              getPageData={getTableData}
              title={title}
              formTemplates={formTemplate}
              arrRefs={arrRefsTable}
              skpEncoding={getState()?.skpEncoding}
              isEdit={true}
              jobDetails={state.jobDetails}
            />
          </>
          : null
        }
      </MainRouteSubRoutePage>
    </>
  )
}

export default EditJob